export type ErrorCodeType =
  | 'needCoinPurchase'
  | 'needUnlimitItem'
  | 'useUnlimitItem'
  | 'needCoin'
  | 'needFan'
  | 'PaperingOn'
  | 'FreezeOn'
  | 'MuteOn'
  | 'recaptcha'
  | 'noExchangeInfo'
  | 'needPw'
  | 'wrongNick'
  | 'existsNick'
  | 'missionTitleBlock'
  | 'wrongId'
  | 'noid'
  | 'wrongPw'
  | 'nopw'
  | 'group-id-nick-overlap'
  | 'leaveReady'
  | 'block'
  | 'overseaLoginBlock'
  | 'loginMust'
  | 'needLogin'
  | 'needAdult'
  | 'castEnd'
  | 'selfWatchMedia'
  | 'overlap'
  | 'blockWatch'
  | 'leakedUser'
  | 'wait'
  | 'toastError';

export interface ApiErrorResponse {
  message: string;
  result: boolean;
  userIp: string;
  errorData?: {
    httpCode?: number;
    code?: ErrorCodeType;
    idx?: number;
    muteTime?: number;
    coin?: string | number;
    info?: {
      coin: number;
      needCoin: number;
      coinHave: number;
    };
    data?: any;
    recoverKey?: string;
    paperingBlockTime?: number;
    needAuth?: boolean;
  };
}

export const isApiErrorResponse = (res: string | object | ApiErrorResponse) => {
  // 객체 타입인지 먼저 체크

  if (typeof res !== 'object' || res === null) return false;

  // 필수 필드 체크
  if (
    typeof (res as ApiErrorResponse).message !== 'string' ||
    typeof (res as ApiErrorResponse).result !== 'boolean' ||
    typeof (res as ApiErrorResponse).userIp !== 'string'
  ) {
    return false;
  }

  // errorData 필드가 존재하는 경우, 세부 검증
  const { errorData } = res as ApiErrorResponse;
  if (errorData) {
    if (errorData.httpCode && typeof errorData.httpCode !== 'number') return false;

    const { info } = errorData;
    if (info) {
      if (typeof info.coin !== 'number' || typeof info.needCoin !== 'number' || typeof info.coinHave !== 'number') {
        return false;
      }
    }
  }

  return true;
};

export const serializeAdditionalContext = (additionalContext: any): string => {
  if (typeof additionalContext === 'string') return additionalContext;
  if (typeof additionalContext === 'number') return additionalContext.toString();
  try {
    if (typeof additionalContext === 'object' && additionalContext !== null) {
      return JSON.stringify(additionalContext, null, 2);
    }
  } catch (error) {
    const errorMessage = (error as Error)?.message || 'Unknown error occurred';
    return `Failed to serialize additional context: ${errorMessage}`;
  }

  return String(additionalContext);
};

export interface BaseHttpResponseErrorParams {
  name: string;
  fetchResponse: Response;
  serverResponse: ApiErrorResponse;
  additionalContext?: any;
}

const defaultResponse: ApiErrorResponse = {
  message: '알 수 없는 오류가 발생했습니다.',
  result: false,
  userIp: '',
};

export class BaseHttpResponseError extends Error {
  readonly additionalContext: any;
  serverResponse: ApiErrorResponse;

  constructor(message: string, httpResponse: string | object, additionalContext: any) {
    super(message);
    this.name = this.constructor.name;
    this.additionalContext = additionalContext;
    this.serverResponse = defaultResponse;

    if (isApiErrorResponse(httpResponse)) {
      this.serverResponse = httpResponse as ApiErrorResponse;
      this.message = this.serverResponse.message;
    }
  }
}
